import { css, html, LitEntity } from '../../utility/lit-entity';
import '../../../parcels/order-editor-button';

class BinProjectionActions extends LitEntity {
  static get styles() {
    return css`
      .action {
        width: 100%;
        margin-top: 1em;
      }
    `;
  }

  render() {
    if (!this.entity || this.entity.properties.isAggregate) {
      return html``;
    }

    return html`
      <div class="action">
        <order-editor-button
          .binHref="${this.href}"
          .style="${{ width: '100%' }}"
        ></order-editor-button>
      </div>
  `;
  }
}

window.customElements.define('bin-projection-actions', BinProjectionActions);
